import * as React from 'react';
import { getResellerType, sendResellerType } from '@/redux/modules/reseller';
import { useAppDispatch, useAppSelector } from '@/redux/hooks';
import { useIntl } from '@liveauctioneers/hammer-ui-core/intl';
import Checkbox from '@liveauctioneers/caterwaul-components/lib/Checkbox/Checkbox';
import ResellerTypes from '@/enums/resellerTypes';
import styled from 'styled-components';

type Props = {
    className?: string;
};

const ResellerCheckbox = ({ className }: Props) => {
    const { formatMessage } = useIntl();
    const dispatch = useAppDispatch();
    const resellerType = useAppSelector(getResellerType);

    const onCheckedValueChange = React.useCallback(() => {
        const newSelection =
            resellerType === ResellerTypes.NOT_A_RESELLER ? ResellerTypes.RESELLER : ResellerTypes.NOT_A_RESELLER;
        dispatch(sendResellerType(newSelection));
    }, [dispatch, resellerType]);

    return (
        <div className={className}>
            <StyledResellerCheckbox
                checked={Boolean(resellerType)}
                label={formatMessage({ id: 'taxExempt' })}
                name="resellerSelection"
                onClick={onCheckedValueChange}
            />
        </div>
    );
};

export default ResellerCheckbox;

const StyledResellerCheckbox = styled(Checkbox)`
    margin-bottom: 0;
`;
